import React from 'react';

// The detail pages' text links (Learn more, FAQs): 14/20 medium brand text, always underlined,
// the size of the text around them (SPEC §E15).
export const DETAIL_LINK_CLASS =
  'inline-flex items-center bg-transparent font-sans text-[length:var(--cs-text-sm)] leading-[var(--cs-leading-20)] font-medium text-[color:var(--cs-brand-text,var(--cs-text-primary))] underline decoration-1 [text-underline-position:from-font] cursor-pointer focus-visible:[outline:var(--cs-focus-outline)] focus-visible:[outline-offset:var(--cs-focus-outline-offset)]';

/**
 * A campaign or event description: the organisation's own HTML in the donor prose recipe
 * (15/22 primary ink). The detail pages and the Learn more sheet both render it, so the text
 * reads the same clipped on the card and in full in the sheet.
 */
export default function DetailDescription({ html, className = '', style }) {
  if (!html) return null;
  return (
    <div
      className={`prose prose-p:my-1 prose-headings:my-1 max-w-none font-sans text-[length:var(--cs-text-sm-plus)] leading-[var(--cs-leading-22)] font-normal text-[color:var(--cs-text-primary)] [font-feature-settings:'calt'_0,'liga'_0] ${className}`.trim()}
      style={{ overflowWrap: 'break-word', wordBreak: 'break-word', ...style }}
    >
      <div className="[&>*:first-child]:mt-0" dangerouslySetInnerHTML={{ __html: html }} />
    </div>
  );
}
